import { AppBrand } from '@ts-brand/enums'

interface SupportContacts {
  phone: string
  whatsUpPhone: string
  email: string
  supportEmail: string
  homework: string
}

const contactsBrighterly: SupportContacts = {
  phone: '19096555569',
  whatsUpPhone: '17252278660',
  email: 'parentcare@brighterly.com',
  supportEmail: 'support@brighterly.com',
  homework: 'https://calendar.app.google/XNy2XoaZTseYKAEi7',
}

const contactsSmartestminds: SupportContacts = {
  phone: '+17255005044',
  whatsUpPhone: '', // must be empty
  email: 'parentcare@smartestminds.com',
  supportEmail: 'parentcare@smartestminds.com',
  homework: '', // must be empty
}

const contactsByBrand: Record<AppBrand, SupportContacts> = {
  [AppBrand.Brighterly]: contactsBrighterly,
  [AppBrand.SmartestMinds]: contactsSmartestminds,
}

export const getContacts = (): SupportContacts => contactsByBrand[useRuntimeConfig().public.brand]
